import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { submitFilterDTO } from 'src/components/Common/UI/DndTable/types';


const convertToDataTable = (data: IGetPhonecentersMaintenance[]): IGetPhonecentersMaintenance[] => {
  const dataTableData: IGetPhonecentersMaintenance[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllPhonecentersMaintenancesList = async (): Promise<IGetPhonecentersMaintenance[]> => {
  const response =  await axiosDefaultApi.get(`/api/PhonecentersMaintenance/GetPhonecentersMaintenance`);
  return convertToDataTable(response as unknown as IGetPhonecentersMaintenance[]);
};

type QueryFnType = typeof getAllPhonecentersMaintenancesList;

type UseGetAllPhonecentersMaintenancesListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllPhonecentersMaintenancesList = ({ config }: UseGetAllPhonecentersMaintenancesListOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllPhonecentersMaintenancesList'],
    queryFn: () => getAllPhonecentersMaintenancesList(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};